import axios from "axios";

export async function fetchAllAreas({ commit }, id) {
  try {
    const { data } = await axios.post(
      `soilAreas/get-areas-by-client-pwa-paged`,
      {
        organizationId: id,
        page: 0,
      }
    );
    let finalAreas = [];

    finalAreas.push(...data.soilAreas);
    let flag = true;
    let page = 1;
    while (flag) {
      let response = await axios.post(
        `soilAreas/get-areas-by-client-pwa-paged`,
        {
          organizationId: id,
          page: page,
        }
      );
      let dataPaged = response.data;
      if (dataPaged.soilAreas.length == 0) {
        flag = false;
      } else {
        finalAreas.push(...dataPaged.soilAreas);
        page++;
      }
    }
    commit("SET_SOIL_AREAS", finalAreas);
    return finalAreas;
  } catch (e) {
    return e;
  } finally {
  }
}

export async function getAreaPaged({ commit }, payload) {
  try {
    const { data } = await axios.post(
      `soilAreas/get-areas-by-client-pwa-paged`,
      {
        organizationId: payload.organizationId,
        page: payload.page,
      }
    );
    return data;
  } catch (e) {
    return e;
  }
}

export async function getAreaFiltered({ commit }, payload) {
  try {
    const { data } = await axios.post(
      `soilAreas/get-areas-by-client-pwa-filtered`,
      {
        organizationId: payload.organizationId,
        page: payload.page,
        name: payload.name,
      }
    );
    return data;
  } catch (e) {
    return e;
  }
}

export async function createArea({ commit }, payload) {
  try {
    const { data } = await axios.post(`soilAreas/create-area`, payload);
    return data;
  } catch (e) {
    return e;
  }
}

export async function getAreaById({ commit }, payload) {
  try {
    const { data } = await axios.get(`soilAreas/${payload}`);
    return data;
  } catch (e) {
    return e;
  }
}

export async function rename({ commit }, payload) {
  try {
    const { data } = await axios.post(`soilAreas/rename`, payload);
    return data;
  } catch (e) {
    return e;
  }
}

export async function deleteArea({ commit }, payload) {
  try {
    const { data } = await axios.post(`soilAreas/delete`, { id: payload });
    return data;
  } catch (e) {
    return e;
  }
}

export async function redrawArea({ commit }, payload) {
  try {
    const { data } = await axios.post(`soilAreas/redraw`, payload);
    return data;
  } catch (e) {
    return e;
  }
}

export async function searchCropZone({ commit }, payload) {
  try {
    const { data } = await axios.post(
      `soilAreas/farm-units-project-search`,
      payload
    );
    return data;
  } catch (e) {
    return e;
  }
}

export async function finishSampling({ commit }, payload) {
  try {
    const { data } = await axios.post(`soilAreas/finish-sampling-v2`, payload);
    return data;
  } catch (e) {
    return e;
  }
}
